import { string } from "prop-types";

const AmsterdamZuidOost = ({ className, lakeClassName }) => (
  <>
    <path
      d="M763.187 748.337L684 604.24L708.455 587.293L705.967 579.86L716.748 574.905L723.589 553.168L712.601 531.134L742.405 515.03L756.453 540.219L801.407 515.03L805.894 525.188L823.723 503.055H849.173L868.503 517.92L891.723 581.512L900.015 598.029L919.088 604.636L936.503 630.238L909.966 656.666L904.162 659.143V677.313L888.406 700.437L845.284 692.178L780.336 748.337H763.187Z"
      fill="url(#paint2_linear_14735_232327)"
      fillOpacity="0.25"
      stroke="#4D4D4D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
      className={className}
    />
    <path
      d="M836.535 625.696L846.113 634.368H889.915L905.82 621.154L895.04 604.637H876.572L875.967 616.199L857.93 619.502L854.406 612.07L836.535 625.696Z"
      stroke="#4D4D4D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
      className={lakeClassName}
    />
    <path
      d="M891.723 581.512L943.552 531.547L944.539 634.367L936.503 630.238L919.088 604.636L900.015 598.029L891.723 581.512Z"
      fill="url(#paint3_linear_14735_232327)"
      fillOpacity="0.25"
      stroke="#4D4D4D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
      className={className}
    />
  </>
);

AmsterdamZuidOost.propTypes = {
  className: string,
  lakeClassName: string,
};

export default AmsterdamZuidOost;
